import { render } from "./OrganicStructureContent.vue?vue&type=template&id=49e0fff7&scoped=true"
import script from "./OrganicStructureContent.vue?vue&type=script&lang=js"
export * from "./OrganicStructureContent.vue?vue&type=script&lang=js"

import "./OrganicStructureContent.vue?vue&type=style&index=0&id=49e0fff7&lang=scss&scoped=true"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e0fff7"]])

export default __exports__